import { useMutation } from '@tanstack/react-query';
import { IReviewBody, sendReview } from '../queries/feedback';

export function useSendFeedbackReview() {
  const { mutate, isPending, isError, isSuccess, data } = useMutation({
    mutationKey: ['feedbackReview'], 
    mutationFn: (body: IReviewBody) => sendReview(body),
    retry: false
  });

  return { mutate, isPending, isError, isSuccess, data };
}